import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH OPERATOR TO EDIT ********************
export const fetchInstitution = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_INSTITUTION_LOADING,
			payload: true
		});

		const response = await services.get(`/productsgroup/${id}`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_INSTITUTION_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_INSTITUTION_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
